// Add your JS customizations here

jQuery(document).ready(function($) {
    // Add your custom jQuery here
    jQuery('.nospam').each(function(){
        var email = jQuery(this).html();
        email = email.replace("[arobase]","@");
        email = email.replace("[point]",".");
        var data = email;
        if(jQuery(this).attr("title") && jQuery(this).attr("title")!="") { data = jQuery(this).attr("title"); }
        jQuery(this).html("<a href=\"mailto:"+email+"\">"+data+"</a>");
    });
});

